import { useCallback, useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import hubLayout from 'styles/css/hubLayout.module.css';
import { SubUser } from 'type/type';
import { getSubUserList } from 'api/api';
import Loading from 'components/common/Loading';
import { useRecoilState } from 'recoil';
import { isDarkAtom } from 'styles/atoms';
import { CommonTable, CommonTableWrap } from 'pages/Layout';
import { formattedDateTime } from 'pages/utils/commonUtils';

function SubUserTable({ idx, subUser }: { idx: number; subUser: SubUser }) {
  const [isShowRecorders, setIsShowRecorders] = useState(false);
  return (
    <>
      <tr>
        <td>{ idx + 1 }</td>
        <td>{ subUser.id }</td>
        <td>{ subUser.name }</td>
        <td>{ subUser.recorder_list?.[0]?.push.all === 1 ? "ON" : "OFF" }</td>
        <td>{ subUser.auth_guard_change ? "ON" : "OFF" }</td>
        <td>{ subUser.auth_live ? "ON" : "OFF" }</td>
        <td>{ subUser.auth_search ? "ON" : "OFF" }</td>
        <td>{ subUser.limit === 0 ? "무제한" : `${subUser.limit}분` }</td>
        <td>{ subUser.access_day === 0 ? "접속 불가" : subUser.access_day === 1 ? "월~금" : "매일" }</td>
        <td>{ `${subUser.access_start_hour}시 ~ ${subUser.access_end_hour}시` }</td>
        <td>{ subUser.last_login_date ? formattedDateTime(subUser.last_login_date) : '' }</td>
        <td><button type="button" className={`${hubLayout.btn} ${hubLayout.medium} ${hubLayout.blue}`} onClick={() => setIsShowRecorders((prev) => !prev)}>보기</button></td>
      </tr>
      {isShowRecorders &&
        <tr>
          <td colSpan={12} style={{ border: '0' }}>
            <CommonTable style={{ width: '100%' }}>
              <tbody className='recorderTbody'>
                <tr>
                  <td>No</td>
                  <td>MAC</td>
                  <td>설치 위치</td>
                  <td>생성일자</td>
                </tr>
                {subUser.recorder_list && subUser.recorder_list.map((recorder, idx) => 
                  <tr key={`recorder_${idx}`}>
                    <td>{ idx + 1 }</td>
                    <td>{ recorder.recorder_mac }</td>
                    <td>{ recorder.reg_name }</td>
                    <td>{ formattedDateTime(recorder.create_date).slice(0, 10) }</td>
                  </tr>
                )}
              </tbody>
            </CommonTable>
          </td>
        </tr>
      }
    </>
  );
}

function SubUserList() {
  const { userId } = useParams();
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const [darkAtom, setDarkAtom] = useRecoilState(isDarkAtom);
  const [totalCount, setTotalCount] = useState(0);
  const [subUserList, setSubUserList] = useState<SubUser[]|[]>([]);

  // 부계정 조회
  const _getSubUserList = useCallback(async () => {
    try {
      setLoading(true);
      const subUserRes = await getSubUserList(0, 0, { user_id: userId });
      if (subUserRes.code === 200) {
        setSubUserList(subUserRes.data);
        setTotalCount(subUserRes.total_count);
      } else {
        alert(subUserRes.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    _getSubUserList();
  }, [_getSubUserList]);
  // Dark mode 상태 설정
  useEffect(() => {
    const isDark = searchParams.get("isDark");
    setDarkAtom(isDark === 'true');
  }, [searchParams, setDarkAtom]);
  return (
    <>
      {loading ? <Loading />
      :
        <div className={`${hubLayout.acc__cnt}`} style={{ padding: "0 20px", display: "flex", flexDirection: "column", gap: "2rem" }}>
          <div className={`${hubLayout.sec_title}`}>
            <h2 style={{ color: darkAtom ? '#fff' : '' }}>{userId} 부계정 목록</h2>
          </div>
          <CommonTableWrap>
            <CommonTable>
              <thead>
                <tr>
                  <th>No</th>
                  <th>ID</th>
                  <th>이름</th>
                  <th>PUSH 전송</th>
                  <th>경계 설정</th>
                  <th>실시간 영상</th>
                  <th>녹화 영상</th>
                  <th>접속 유지 시간</th>
                  <th>접속 가능 요일</th>
                  <th>접속 가능 시간</th>
                  <th>최근 로그인 일자</th>
                  <th>장비</th>
                </tr>
              </thead>
              <tbody>
                {totalCount === 0 ?
                  <tr><td colSpan={12}>검색결과가 없습니다.</td></tr>
                  :
                  subUserList.map((subUser, idx) => (
                    <SubUserTable key={`sub_user_${idx}`} idx={idx} subUser={subUser} />
                  ))
                }
              </tbody>
            </CommonTable>
          </CommonTableWrap>
        </div>
      }
    </>
  );
}

export default SubUserList;